module.exports = __webpack_public_path__ + "img/step5-en.36306e03.webp";